<template>
  <GridBase main>
    <section class="s1" @wheel="handleScroll"
    @touchstart="touchStart"
    @touchend="touchEnd">
      <div class="main-visual">
        <div id="current-target" class="cont">
          <div class="cont__title-wrap">
            <TextBlock file="main/main-t1" class="cont__title" out-only></TextBlock>
          </div>
          <a href="javascript:void(0)" class="btn-arrow" data-move-id="scroll-target" data-move-page="" @click="onClickMoveButton"><span class="blind">다음 섹션으로 이동</span></a>
        </div>
        <div id="scroll-target" class="track-animation is-not-fixed">
          <div class="track-animation__fixed">
            <div class="video__player loaded">
              <video v-if="kr" ref="video" src="https://vod-homepage.pstatic.net/cdn-vod/datacenter/main.mp4" muted autoplay loop playsinline></video>
              <video v-else ref="video" src="https://vod-homepage.pstatic.net/cdn-vod/datacenter/main_en.mp4" muted autoplay loop playsinline></video>
              <picture class="video__image track-animation__image">
                <source media="(min-width: 768px)" srcset="/img/main/s1-bg.jpg">
                <source media="(min-width: 0)" srcset="/img/main/s1-bg-s.jpg">
                <img src="" alt="">
              </picture>
              <button v-if="kr" type="button" class="sound-btn" :class="{'is-mute': vidMuted }" @click="soundControl"><span class="blind">{{ vidMuted ? '음소거 해제' : '음소거' }}</span></button>
              <button v-else type="button" class="sound-btn" :class="{'is-mute': vidMuted }" @click="soundControl"><span class="blind">{{ vidMuted ? 'Unmute' : 'Mute' }}</span></button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="s2">
      <div class="sejong">
        <div class="img-box"></div>
        <div class="section-title">
          <h3><TextBlock file="main/main-t2" out-only></TextBlock></h3>
          <div class="btn-wrap">
            <button v-if="kr" type="button" class="btn-more" @click="$router.push('gak/gak-sejong')"><span><s>GAK Sejong</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
            <button v-else type="button" class="btn-more" @click="$router.push('gak/gak-sejong')"><span>Go to GAK Sejong</span><Icon class="icon-arrow-right-white"></Icon></button>
          </div>
        </div>
      </div>
      <div class="chuncheon">
        <div class="img-box">
          <img src="/img/main/s2-chuncheon.jpg" class="hidden-sm-down" alt="">
          <img src="/img/main/s2-chuncheon-s.jpg" class="hidden-md-up" alt="">
        </div>
        <div class="text-box">
          <h3><TextBlock file="main/main-t3" out-only></TextBlock></h3>
          <div class="btn-wrap">
            <button v-if="kr" type="button" class="btn-more" @click="$router.push('gak/gak-chuncheon')"><span><s>GAK Chuncheon</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
            <button v-else type="button" class="btn-more" @click="$router.push('gak/gak-chuncheon')"><span>Go to GAK Chuncheon</span><Icon class="icon-arrow-right-white"></Icon></button>
          </div>
        </div>
      </div>
      <div class="global">
        <div class="img-box">
          <img src="/img/main/s2-global.jpg" class="hidden-sm-down" alt="">
          <img src="/img/main/s2-global-s.jpg" class="hidden-md-up" alt="">
        </div>
        <div class="text-box">
          <h3><TextBlock file="main/main-t4" out-only></TextBlock></h3>
          <div class="btn-wrap">
            <button v-if="kr" type="button" class="btn-more" @click="$router.push('gak/gak-global')"><span><s>GAK Global</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
            <button v-else type="button" class="btn-more" @click="$router.push('gak/gak-global')"><span>Go to GAK Global</span><Icon class="icon-arrow-right-white"></Icon></button>
          </div>
        </div>
      </div>
    </section>
    <section class="s3">
      <div class="section-title">
        <h3><TextBlock file="main/main-t5" out-only></TextBlock></h3>
        <div class="btn-wrap">
          <button v-if="kr" type="button" class="btn-more" @click="$router.push('data/our-data')"><span><s>Our Data</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
          <button v-else type="button" class="btn-more" @click="$router.push('data/our-data')"><span>Go to Our Data</span><Icon class="icon-arrow-right-white"></Icon></button>
        </div>
      </div>
      <div class="cont">
        <div class="img-box">
          <img src="/img/main/s3-idea.jpg" class="hidden-sm-down" alt="">
          <img src="/img/main/s3-idea-s.jpg" class="hidden-md-up" alt="">
        </div>
        <div class="text-box">
          <h3><TextBlock file="main/main-t6" out-only></TextBlock></h3>
          <div class="btn-wrap">
            <button v-if="kr" type="button" class="btn-more" @click="$router.push('data/our-idea')"><span><s>Our Idea</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
            <button v-else type="button" class="btn-more" @click="$router.push('data/our-idea')"><span>Go to Our Idea</span><Icon class="icon-arrow-right-white"></Icon></button>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="img-box">
          <img src="/img/main/s3-brand.jpg" class="hidden-sm-down" alt="">
          <img src="/img/main/s3-brand-s.jpg" class="hidden-md-up" alt="">
        </div>
        <div class="text-box">
          <h3><TextBlock file="main/main-t7" out-only></TextBlock></h3>
          <div class="btn-wrap">
            <button v-if="kr" type="button" class="btn-more" @click="$router.push('data/our-brand')"><span><s>Our Brand</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
            <button v-else type="button" class="btn-more" @click="$router.push('data/our-brand')"><span>Go to Our Brand</span><Icon class="icon-arrow-right-white"></Icon></button>
          </div>
        </div>
      </div>
    </section>
    <section class="s4">
      <div class="main">
        <h2><TextBlock file="main/main-t8" out-only></TextBlock></h2>
      </div>
      <div class="wrap">
        <div class="cont">
          <div class="img-box">
            <img src="/img/main/s4-tech.jpg" class="hidden-sm-down" alt="">
            <img src="/img/main/s4-tech-s.jpg" class="hidden-md-up" alt="">
          </div>
          <div class="text-box">
            <h3><TextBlock file="main/main-t9" out-only></TextBlock></h3>
            <div class="btn-wrap">
              <button v-if="kr" type="button" class="btn-more" @click="$router.push('tech/technology')"><span><s>Technology</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
              <button v-else type="button" class="btn-more" @click="$router.push('tech/technology')"><span>Go to Technology</span><Icon class="icon-arrow-right-white"></Icon></button>
            </div>
          </div>
        </div>
        <!-- people 오픈 전 임시 친환경 섹션 적용 -->
        <div class="cont">
          <div class="img-box">
            <img src="/img/main/s4-eco.png" class="hidden-sm-down" alt="">
          <img src="/img/main/s4-eco-s.png" class="hidden-md-up" alt="">
          </div>
          <div class="text-box">
            <h3><TextBlock file="main/main-t10" out-only></TextBlock></h3>
            <div class="btn-wrap">
              <button v-if="kr" type="button" class="btn-more" @click="$router.push('esg/leed-platinum')"><span><s>LEED Platinum</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
              <button v-else type="button" class="btn-more" @click="$router.push('esg/leed-platinum')"><span>Go to LEED Platinum</span><Icon class="icon-arrow-right-white"></Icon></button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="s5">
      <div class="cont">
        <div class="img-box"></div>
        <div class="text-box">
          <h3><TextBlock file="main/main-t12" out-only></TextBlock></h3>
          <div class="btn-wrap">
            <button v-if="kr" type="button" class="btn-more" @click="$router.push('esg/green-energy')"><span><s>Green Energy</s>바로 가기</span><Icon class="icon-arrow-right-white"></Icon></button>
            <button v-else type="button" class="btn-more" @click="$router.push('esg/green-energy')"><span>Go to Green Energy</span><Icon class="icon-arrow-right-white"></Icon></button>
          </div>
        </div>
      </div>
    </section>
  </GridBase>
</template>

<script>
// import _ from 'lodash';
import GridBase from '@/views/components/GridBase';
import TextBlock from '@/views/components/TextBlock';
import Icon from '@/views/components/Icon';

export default {
  name: 'Main',
  components: { GridBase, TextBlock, Icon },
  data() {
    return {
      vidMuted: true, 
      touchStartY: 0,
      touchEndY: 0,
      threshold: 50,
    };
  },
  methods: {
    onClickMoveButton(e) {
      e.preventDefault();

      const currentTarget = e.currentTarget;
      const currentID = currentTarget.dataset.moveId;
      const targetElement = document.getElementById(currentID);

      const targetOffset = targetElement.offsetTop;

      const halfWindowHeight = window.innerHeight / 2;

      const scrollToPosition = targetOffset - halfWindowHeight + (targetElement.offsetHeight / 2) + 64;

      //swing
      const easing = (x) => {
        return 0.5 - Math.cos(x * Math.PI) / 2;
      };

      const startScroll = document.documentElement.scrollTop;
      const duration = 800;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easedProgress = easing(progress);
        
        window.scrollTo(0, startScroll + (scrollToPosition - startScroll) * easedProgress);
      
        if (elapsedTime < duration) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    },
    soundControl(e) {
      e.preventDefault();
      const vid = this.$refs.video;
      vid.muted = !vid.muted;
      this.vidMuted = vid.muted;
    },
    smoothScroll(targetPosition, duration) {
      const startPosition = document.documentElement.scrollTop;
      const distance = targetPosition - startPosition;
      // const duration = test;
      let startTime = null;

      const easing = (x) => {
        return 0.5 - Math.cos(x * Math.PI) / 2;
      };

      const scrollAnimation = (currentTime) => {
        if(startTime === null) startTime = currentTime;
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easedProgress = easing(progress);
        window.scrollTo(0, startPosition + distance * easedProgress);

        if(elapsedTime < duration) {
          requestAnimationFrame(scrollAnimation);
        }
      }
      requestAnimationFrame(scrollAnimation);
    },
    handleScroll(e) {
      const deltaY = e.deltaY;
      // const currentSection = document.querySelector('#current-target');
      const videoSection = document.querySelector('#scroll-target');
      const currentScroll = window.scrollY;

      if(deltaY > 0 && videoSection.offsetTop > Math.floor(currentScroll+1)) {
        // window.scrollTo(0,videoSection.offsetTop);
        this.smoothScroll(videoSection.offsetTop, 300);
      }

    },
    touchStart(e) {
      this.startY = e.touches[0].clientY;
    },
    touchEnd(e) {
      this.endY = e.changedTouches[0].clientY;
      const currentScroll = window.scrollY;

      const videoSection = document.querySelector('#scroll-target');

      if(this.endY < this.startY && videoSection.offsetTop > Math.floor(currentScroll+1)) {
        this.smoothScroll(videoSection.offsetTop, 600);
      }

      console.dir(this.smoothScroll);
    }
  },
  mounted() {},
  beforeUnmount() {},
};
</script>